import { Component, ElementRef, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CameraEnhancer, CameraView, EnumEnhancedFeatures } from 'dynamsoft-camera-enhancer';
import { CaptureVisionRouter } from 'dynamsoft-capture-vision-router';
import '../../dynamsoft.config';
import { DataService } from 'src/app/common/services/data.service';
import { EnumBarcodeFormat } from 'dynamsoft-barcode-reader-bundle';

const componentDestroyedErrorMsg = 'VideoCapture Component Destroyed';

@Component({
  selector: 'app-barcode-scanner',
  standalone: false,
  templateUrl: './barcode-scanner.component.html',
  styleUrl: './barcode-scanner.component.css'
})
export class BarcodeScannerComponent implements OnInit {
  resultText: string;
  constructor(private readonly router: Router, private readonly dataService: DataService) { }

  @Output() scanPart: any;
  @ViewChild('cameraViewContainer') cameraViewContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('results') resultsContainer?: ElementRef<HTMLDivElement>;
  scanPartDetail: any[] = [];

  resolveInit?: () => void;
  pInit: Promise<void> = new Promise((r) => {
    this.resolveInit = r;
  });

  isDestroyed = false;
  cvRouter?: CaptureVisionRouter;
  cameraEnhancer?: CameraEnhancer;

  async ngOnInit(): Promise<void> {
    try {
      const cameraView = await CameraView.createInstance();
      this.cameraEnhancer = await CameraEnhancer.createInstance(cameraView);
      this.cvRouter = await CaptureVisionRouter.createInstance();


      await this.cameraEnhancer.setResolution({ width: 1920, height: 1080 });
      //await this.cameraEnhancer.enableEnhancedFeatures(EnumEnhancedFeatures.EF_TAP_TO_FOCUS);

      this.cameraViewContainer?.nativeElement.append(cameraView.getUIElement());

      let settings: any = await this.cvRouter.getSimplifiedSettings('ReadSingleBarcode');
      settings.barcodeSettings.barcodeFormatIds = EnumBarcodeFormat.BF_PDF417 | EnumBarcodeFormat.BF_QR_CODE; //format selector
      settings.barcodeSettings.expectedBarcodesCount = 1;
      settings.barcodeSettings.grayscaleTransformationModes[0] = 2;
      await this.cvRouter.updateSettings('ReadSingleBarcode', settings);
      this.cvRouter.setInput(this.cameraEnhancer);
      await this.cameraEnhancer.open();
      await this.cameraEnhancer.setZoom({
        factor: 1.0
      });
      await this.cvRouter.startCapturing('ReadSingleBarcode');
      cameraView.setScanLaserVisible(false);

      this.cvRouter.addResultReceiver({
        onDecodedBarcodesReceived: (result) => {
          console.log("result", result);
          if (!result.barcodeResultItems.length) return;
          if (result) {
            for (let item of result.barcodeResultItems) {
              setTimeout(() => {
                this.router.navigate([`/create-hot-call`], { queryParams: { scannedResult: item.text } });
                this.cvRouter?.stopCapturing();
              }, 1000);
            }
          }
        }
      });
    } catch (ex: any) {
      if ((ex as Error)?.message === componentDestroyedErrorMsg) {
        console.log(componentDestroyedErrorMsg);
      } else {
        let errMsg = ex.message || ex;
        console.error(errMsg);
        alert(errMsg);
      }
    }

    this.resolveInit();
  }

  async ngOnDestroy() {
    this.isDestroyed = true;
    try {
      await this.pInit;
      this.cvRouter?.dispose();
      this.cameraEnhancer?.dispose();
    } catch (_) { }
  }
}